var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){return _vm.jsonExport(_vm.workflows)}}},[_vm._v(" "+_vm._s(_vm.$t('general:export'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }